import React from 'react';

import Activity from './Activity';
import { SectionTitle } from '../../Global/styles';

import {
	ActivitesContainer,
	ActivitySwiper,
	ActivitySwiperSlide,
} from './ActivitiesStyles';
import { ITaxonomy } from '../../../models/interfaces/ITaxonomy';

type ActivitiesProps = {
	activities: ITaxonomy[];
};

const Activities: React.FC<ActivitiesProps> = ({ activities }) => {
	return (
		<ActivitesContainer>
			<SectionTitle>Activities</SectionTitle>
			<ActivitySwiper
				slidesPerView={'auto'}
				spaceBetween={32}
				className="activities-swiper">
				{activities.map((activity) => {
					return (
						<ActivitySwiperSlide key={activity.id ?? activity.slug ?? activity.title}>
							<Activity activity={activity} />
						</ActivitySwiperSlide>
					);
				})}
			</ActivitySwiper>
		</ActivitesContainer>
	);
};

export default Activities;
